/** Screen frame: safe areas and bottom padding for the tab bar. */
import type { ReactElement, ReactNode } from "react";
import { useLocation } from "react-router-dom";
import { isTabRoot, type TabKey } from "./TabBar";
export function Screen({ children, tab, className = "", title }: { children: ReactNode; tab?: TabKey | undefined; className?: string; title?: string }): ReactElement {
  // Room for the tab bar wherever it shows (D-171: every page but the table and a few full-screen ones).
  const tabbed = isTabRoot(useLocation().pathname);
  void tab;
  return <main className={`screen ${tabbed ? "screen--tabbed" : "screen--plain"} ${className}`} aria-label={title}>{children}</main>;
}
